import React from "react";
import { Box, Grid2, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CircleBox } from "@features/recommender/common";
import { TypographyWithInfoIcon } from "@rentablo/components";

type Props = {
  investmentName: string;
  recommendationName: string;
};

export const HeaderRow = ({ investmentName, recommendationName }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const text = t("recommender.compareView.productInfo.header.productDataOf", {
    name: investmentName,
  });

  const recommendationText = t(
    "recommender.compareView.productInfo.header.productDataOf",
    {
      name: recommendationName,
    }
  );

  return (
    <Grid2
      container
      alignItems="center"
      spacing={2}
      sx={{
        pt: 2,
        pb: 4,
        borderBottom: `1px solid ${theme.palette.border.secondary}`,
      }}
    >
      <Grid2
        size={{ xs: 0, md: 4 }}
        sx={{ display: { xs: "none", md: "block" } }}
      >
        <Typography
          variant="caption"
          fontWeight={600}
          color="textSecondary"
          ml={3}
        >
          {t("recommender.compareView.productInfo.header.label")}
        </Typography>
      </Grid2>
      <Grid2 size={{ xs: 6, md: 4 }}>
        <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
          <CircleBox
            sx={{
              backgroundColor: theme.palette.graphVisual["06"].mid,
            }}
          />
          <TypographyWithInfoIcon
            variant="caption"
            fontWeight={600}
            color="textSecondary"
            tooltipText={text}
            truncate
            hideIcon
            mr={2}
          >
            {text}
          </TypographyWithInfoIcon>
        </Box>
      </Grid2>
      <Grid2 size={{ xs: 6, md: 4 }}>
        <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
          <CircleBox
            sx={{
              backgroundColor: theme.palette.graphVisual["02"].mid,
            }}
          />
          <TypographyWithInfoIcon
            variant="caption"
            fontWeight={600}
            color="textSecondary"
            tooltipText={recommendationText}
            truncate
            hideIcon
            mr={2}
          >
            {recommendationText}
          </TypographyWithInfoIcon>
        </Box>
      </Grid2>
    </Grid2>
  );
};
